// FR: Définit une fonction pour formater une date dans un format lisible, en utilisant les paramètres de localisation.
// EN: Defines a function to format a date into a readable format, using locale settings.
export const formatDate = (
    date: any, 
    locale: string = 'default'
): string => {

    date = new Date(date);

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
    };

    return new Intl.DateTimeFormat(locale, options).format(date);
}

export const toIsoDate = (date: string | number | Date): string => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split('T')[0]; // "2023-11-30"
};

export const toIsoDateFr = (date: string | number | Date): string => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString('fr-FR');
}

// FR: Définit une fonction pour formater l'heure dans un format lisible, en utilisant les paramètres de localisation.
// EN: Defines a function to format time into a readable format, using locale settings.
export const formatTime = (
    date: any, 
    locale: string = 'default'
): string => {

    date = new Date(date);

    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };

    return new Intl.DateTimeFormat(locale, options).format(date);
}

export const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export   const showPickerByRef = (ref: React.RefObject<HTMLInputElement>) => {
    if (ref.current) {
        if (ref.current.showPicker) {
            ref.current.showPicker();
        } else {
            ref.current.focus();
        }
    }
};
